import React, { useState, useEffect } from 'react';
import { Switch, Select, Table, Tag, Modal, Row, Col, Button, Form, Input, DatePicker, Radio } from 'antd';
import UilTrashAlt from '@iconscout/react-unicons/icons/uil-trash-alt';
import { PageHeader } from '../components/page-headers/page-headers';
import axios from '../backendService';
import { GlobalUtilityStyle, PaginationStyle } from '../container/styled';
import { BiEditAlt } from 'react-icons/bi';
import UserModal from './UserModal';
import moment from 'moment';
import defaultProfilePic from './Default_pfp.svg.png'; // Ensure the path is correct

const { Option } = Select;
const { confirm } = Modal;
function User() {
  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [roleId, setRoleId] = useState('all');
  const [searchText, setSearchText] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null); // Add this line

  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [batches, setBatches] = useState([]);

  const [form] = Form.useForm();

  useEffect(() => {
    // Fetch subjects data from /subjects API endpoint
    const fetchSubjects = async () => {
      try {
        const response = await axios.get('/subjects');
        setSubjects(response.data.data);
      } catch (error) {
        console.error('Error fetching subjects:', error);
      }
    };

    // Fetch courses data from /courses API endpoint
    const fetchCourses = async () => {
      try {
        const response = await axios.get('/courses');
        setCourses(response.data.data);
      } catch (error) {
        console.error('Error fetching courses:', error);
      }
    };

    // Fetch batches data
    const fetchBatches = async () => {
      try {
        const response = await axios.get('/batch');
        setBatches(response.data.allBatches);
      } catch (error) {
        console.error('Error fetching batches:', error);
      }
    };

    // Call the functions to fetch subjects and courses
    fetchSubjects();
    fetchCourses();
    fetchBatches();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`/users`);
      // Sort the records by _id in descending order assuming the _id increments with each new record
      const sortedData = response.data.data.sort((a, b) => {
        return b._id.localeCompare(a._id);
      });
      // console.log(sortedData);
      setData(sortedData);
      setFilterData(sortedData); // Set the sorted data
      const apiRes = await axios.get('/roles');
      setRoles(apiRes.data.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  // Get the data from backend
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    let filteredData = data;
    // // Filter by role
    if (selectedRole === 'Student') {
      filteredData = filteredData.filter((item) => item.userType === 1);
    } else if (selectedRole === 'Teacher') {
      filteredData = filteredData.filter((item) => item.userType === 2);
    } else if (selectedRole === 'Admin') {
      filteredData = filteredData.filter((item) => item.userType === 3);
    } else if (selectedRole === 'Content Management') {
      filteredData = filteredData.filter((item) => item.userType === 4);
    }
    // Filter by search text
    if (searchText) {
      filteredData = filteredData.filter(
        (item) =>
          item.userName.toLowerCase().includes(searchText.toLowerCase()) ||
          // item.phoneNumber.includes(searchText)
          item.phoneNumber.toString().includes(searchText),
      );
    }
    setFilterData(filteredData);
  }, [roleId, searchText, data]);

  // Delete the course
  const onDelete = async (id) => {
    try {
      const response = await axios.delete(`/users/${id}`);
      if (response.status === 200) {
        // Remove the deleted item from the list
        setFilterData((prevItems) => prevItems.filter((item) => item._id !== id));
      } else {
        console.log(response.data.message); // Handle error messages from the server
      }
    } catch (error) {
      console.log('Internal server error');
    }
  };

  // Confirm modal
  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Are you sure you want to delete this user?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDelete(id);
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  // Function to open the UserModal for adding a new user
  const handleAddUser = () => {
    setEditingUser(null);
    setModalVisible(true);
  };

  // Function to open the UserModal for editing an existing user
  const handleEditUser = (user) => {
    setEditingUser(user);
    setModalVisible(true);
  };

  // Function to close the UserModal
  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleSwitchToggle = async (id, enabled) => {
    try {
      const response = await axios.put(`/users/${id}`, { isActive: enabled });
      await fetchData();
      // await fetchUsers();
    } catch (error) {
      console.error('Error updating switch status:', error);
    }
  };

  const handleModalSave = async (values) => {
    try {
      // Replace null values with empty arrays
      const sanitizedValues = {
        ...values,
        courses: values.courses || [], // Ensure courses is initialized as an empty array
        batches: values.batches || [], // Ensure batches is initialized as an empty array
        subjects: values.subjects || [], // Ensure subjects is initialized as an empty array
      };
      // console.log("form submit valuesssssssss", sanitizedValues)
      if (editingUser) {
        // Editing existing user
        const res = await axios.put(`/users/${editingUser._id}`, sanitizedValues);
        // console.log("res", res)
      } else {
        // Adding new user
        const res = await axios.post('/users/register', sanitizedValues);
        // console.log("res", res)
      }
      // console.log('User saved successfully');
      fetchData();
      setModalVisible(false);
    } catch (error) {
      console.error('Error saving user:', error);
    }
  };

  const columns = [
    // {
    //   title: 'Image',
    //   key: 'image',
    //   render: (text, record) => (
    //     <img
    //       src={record.image}
    //       alt={record.userName}
    //       style={{ width: '50px', height: '50px', borderRadius: '50%' }}
    //     />
    //   ),
    // },
    {
      title: 'Image',
      key: 'image',
      hidden: selectedRole === 'Content Management' || selectedRole === 'Admin',
      render: (text, record) => {
        const imageUrl = record.image && record.image.startsWith('data:image') ? record.image : defaultProfilePic;
        return (
          <img
            src={imageUrl}
            alt={record.userName}
            style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }}
          />
        );
      },
    },
    { title: 'Name', dataIndex: 'userName', key: 'userName' },
    { title: 'Number', dataIndex: 'phoneNumber', key: 'phoneNumber' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    // { title: 'userType', dataIndex: 'userType', key: 'userType' },
    {
      title: 'Date of Birth',
      dataIndex: 'dob',
      key: 'dob',
      hidden: selectedRole === 'Content Management',
      render: (dob) => {
        const formattedDob = new Date(dob).toLocaleDateString('en-GB');
        return formattedDob;
      },
    },
    {
      title: 'City',
      dataIndex: 'city',
      key: 'city',
      hidden: selectedRole === 'Content Management' || selectedRole === 'Admin',
    },
    {
      title: 'State',
      dataIndex: 'state',
      key: 'state',
      hidden: selectedRole === 'Content Management' || selectedRole === 'Admin',
    },
    {
      title: 'Gender',
      dataIndex: 'gender',
      key: 'gender',
      hidden: selectedRole === 'Content Management' || selectedRole === 'Admin',
    },
    {
      title: 'RefCode',
      dataIndex: 'refCode',
      key: 'refCode',
      hidden: selectedRole === 'Content Management' || selectedRole === 'Admin',
    },
    {
      title: 'Wallet Points',
      dataIndex: 'walletPoint',
      key: 'walletPoint',
      align: 'center',
      hidden: selectedRole === 'Content Management' || selectedRole === 'Admin',
    },
    {
      title: 'Courses',
      dataIndex: 'courses',
      key: 'courses',
      hidden: selectedRole === 'Content Management' || selectedRole === 'Admin',
      render: (courses) => (
        <span>
          {courses && courses.length > 0 ? (
            courses.map((course) => (
              <Tag key={course._id} color="blue">
                {course.courseName}
              </Tag>
            ))
          ) : (
            <span>No courses</span> // Modify this message as needed
          )}
        </span>
      ),
    },
    {
      title: 'Batches',
      dataIndex: 'batches',
      key: 'batches',
      hidden: selectedRole === 'Content Management' || selectedRole === 'Admin',
      render: (batches) => (
        <span >
        {batches && batches.length > 0 ? (
            batches.map((batch) => (
              <Tag key={batch._id} color="blue">
                {batch.name}
              </Tag>
            ))
          ) : (
            <span>No batches</span> // Modify this message as needed
          )}
        </span>
      ),
    },
    // {
    //   title: 'Courses',
    //   dataIndex: 'courses',
    //   key: 'courses',
    //   render: (courses) => (
    //     <span>
    //       {courses.map((course) => (
    //         <Tag key={course._id} color="blue">
    //           {course.courseName}
    //         </Tag>
    //       ))}
    //     </span>
    //   ),
    // },

    // {
    //   title: 'Subjects',
    //   dataIndex: 'subjects',
    //   key: 'subjects',
    //   render: (subjects) => (
    //     <span>
    //       {subjects.map((subject) => (
    //         <Tag key={subject._id} color="blue">
    //           {subject.subjectName}
    //           {/* {subject} */}
    //         </Tag>
    //       ))}
    //     </span>
    //   ),
    // },
    {
      title: 'Subjects',
      dataIndex: 'subjects',
      key: 'subjects',
      hidden: selectedRole === 'Student' || selectedRole === 'Admin',
      render: (subjects) => (
        <span>
          {subjects && subjects.length > 0 ? (
            subjects.map((subject) => (
              <Tag key={subject._id} color="blue">
                {subject.subjectName}
              </Tag>
            ))
          ) : (
            <span>No subjects</span> // You can modify this to display something else if no subjects are available
          )}
        </span>
      ),
    },
    { title: 'Password', dataIndex: 'password', key: 'password', hidden: selectedRole === 'Student' },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (enabled, record) => (
        <Switch checked={enabled} size="small" onChange={(checked) => handleSwitchToggle(record._id, checked)} />
      ),
    },
    {
      title: 'Actions',
      dataIndex: '_id',
      key: 'actions',
      width: '90px',
      render: (id, record) => (
        <div className="flex">
          <BiEditAlt
            className="mx-2 w-4 h-4 cursor-pointer text-light dark:text-white60 hover:text-success dark:hover:text-success"
            onClick={() => handleEditUser(record)}
          />
          <UilTrashAlt
            className="mx-2 w-4 h-4 cursor-pointer text-light dark:text-white60 hover:text-danger dark:hover:text-danger"
            onClick={() => showDeleteConfirm(id)}
          />
        </div>
      ),
    },
  ];

  // // Filter columns based on selected role
  // const filteredColumns = columns.filter((column) => {
  //   // if (selectedRole === 'Teacher' && column.key === 'courses') {
  //   //   return false; // Exclude the 'Courses' column when the role is 'Teacher'
  //   // }
  //   if (selectedRole === 'Student' && column.key === 'password') {
  //     return false; // Exclude the 'Courses' column when the role is 'Teacher'
  //   }
  //   return true; // Include other columns
  // });

  // Filter columns based on conditions
  const filteredColumns = columns.filter((column) => !column.hidden);

  const handleStatus = (value) => {
    setRoleId(value);
    const fetchRoleName = roles.find((item) => item._id === value)?.roleName || 'all';
    setSelectedRole(fetchRoleName);
  };

  return (
    <>
      <PageHeader
        className="flex items-center justify-between px-8 xl:px-[15px] pt-7 pb-6 sm:pb-[30px] bg-transparent sm:flex-col"
        // title={showStudents ? 'Student' : 'Teacher'}
      />
      <main className="min-h-[715px] lg:min-h-[580px] px-8 xl:px-[15px] bg-transparent">
        <Row gutter={30}>
          <Col xs={24}>
            <div className="bg-white dark:bg-white10 m-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative p-[25px]">
              <div className="text-dark dark:text-white87 font-medium text-[17px] flex items-center justify-between gap-[15px] sm:justify-left mb-5">
                <div className="flex items-center gap-[15px]">
                  <h1 className="mb-0 mr-12 text-ellipsis text-[18px] font-semibold sm:text-center">Users</h1>
                  {/* <span className="ltr:mr-2 rtl:ml-2 dark:text-white60">Role:</span> */}
                  <Select value={roleId} onChange={handleStatus} style={{ width: 180 }}>
                    <Option value="all">All</Option>
                    {roles.map((role) => (
                      <Option key={role._id} value={role._id}>
                        {role.roleName}
                      </Option>
                    ))}
                  </Select>
                  <Input
                    maxLength={15}
                    placeholder="Search by Name or Phone Number"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    // style={{ width: 200, marginBottom: 20 }}
                    className="w-[150px]"
                    allowClear // enable clear button
                  />
                </div>
                <Button
                  onClick={handleAddUser}
                  className="h-[50px] px-6 text-xs font-medium bg-primary-transparent text-primary border-none"
                  transparented
                  type="primary"
                  size="large"
                >
                  + Add User
                </Button>
              </div>

              <div className="mt-0.5">
                <GlobalUtilityStyle>
                  <PaginationStyle>
                    <div className="ant-pagination-custom-style table-responsive hover-tr-none table-th-shape-none table-last-th-text-right table-th-border-none table-head-rounded table-selection-col-pl-25 table-tr-selected-background-transparent table-td-border-none bg-white dark:bg-transparent rounded-[10px] ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:first-child]:rounded-none ltr:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-r-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-l-10 rtl:[&>div>div>div>div>div>.ant-table-content>table>thead>tr>th:last-child]:rounded-none">
                      <Table
                        key={data.length} // or another key that changes when data changes
                        dataSource={filterData.sort((a, b) => b.id - a.id)}
                        columns={filteredColumns}
                        rowKey={(record) => record._id}
                        pagination={{
                          defaultPageSize: 6,
                          total: filterData.length,
                          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                          hideOnSinglePage: true, // Hides the pagination if there is only one page
                          showSizeChanger: false, // This will hide the page size selector
                          className:
                            '[&>.ant-pagination-total-text]:border-none ssm:[&>.ant-pagination-total-text]:w-full [&>.ant-pagination-total-text]:text-center [&>.ant-pagination-total-text]:text-dark dark:[&>.ant-pagination-total-text]:text-white87 [&>.ant-pagination-total-text]:font-medium [&>.ant-pagination-total-text]:text-[17px md:justify-center',
                        }}
                      />
                    </div>
                  </PaginationStyle>
                </GlobalUtilityStyle>
              </div>
            </div>
            {/* Add/Edit User Modal */}
            <UserModal
              visible={modalVisible}
              onCancel={handleModalCancel}
              onSave={handleModalSave}
              user={editingUser}
              roles={roles}
              courses={courses}
              subjects={subjects}
              batches={batches}
            />
          </Col>
        </Row>
      </main>
    </>
  );
}

export default User;
